import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { UserProfileComponent } from '@pg-app/partner/user-profile/containers/user-profile.component';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { ManageRecipientModule } from '@pg-app/client/manage-recipient/manage-recipient.module';
import { BankAccountDetailsComponent } from './bank-account-details/bank-account-details.component';
import { UserProfileRoutingModule } from '@pg-app/partner/user-profile/user-profile.routing';
import { PipeModule } from '@nttp/pipes/pipe.module';

@NgModule({
  declarations: [UserProfileComponent, BankAccountDetailsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UserProfileRoutingModule,
    CoreMaterialModule,
    CommonDialogModule,
    ManageRecipientModule,
    PipeModule
  ]
})
export class UserProfileModule { }
